export default {"src":"/_next/static/media/img-mask-front.ac16a775.svg","height":300,"width":300,"blurWidth":0,"blurHeight":0};